import { render, staticRenderFns } from "./ScreensSingleOverview.vue?vue&type=template&id=34cb6ba2&scoped=true&"
import script from "./ScreensSingleOverview.vue?vue&type=script&lang=js&"
export * from "./ScreensSingleOverview.vue?vue&type=script&lang=js&"
import style0 from "./ScreensSingleOverview.vue?vue&type=style&index=0&id=34cb6ba2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cb6ba2",
  null
  
)

export default component.exports